import { apiSlice } from 'store/slices/api/api-slice';
import {
    NotificationIdResponse,
    NotificationListResponse,
    NotificationSystemListRequest,
} from 'types/notification/notification';

export const notificationList = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        notificationList: builder.query<
            NotificationListResponse,
            NotificationSystemListRequest
        >({
            query: (params: NotificationSystemListRequest) => ({
                url: '/notification/get-notification-list',
                method: 'GET',
                params: params,
            }),
        }),

        notificationId: builder.query<NotificationIdResponse, string>({
            query: (notificationId: string) =>
                `/notification/notification/${notificationId}`,
        }),
    }),
});

export const { useLazyNotificationListQuery, useLazyNotificationIdQuery } =
    notificationList;
